
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 0a10 10 0 1010 10A10 10 0 0010 0zm3.46 14.952l-3.453-3.418L6.576 15l-1.529-1.527 3.42-3.464L5 6.576l1.527-1.529L9.99 8.465 13.412 5l1.541 1.541-3.417 3.451L15 13.412z","fill":"#fd352e"}}),_c('path',{attrs:{"d":"M15.037 13.442L11.56 10.01l3.429-3.463L13.442 5l-3.433 3.479-3.476-3.431L5 6.582l3.48 3.446L5.048 13.5l1.534 1.532 3.444-3.479 3.465 3.431z","fill":"#fff"}})])
          )
        }
      }
    